import React from 'react';
import { css } from '@emotion/core';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';
import { FaChevronDown, FaWhatsapp } from 'react-icons/fa';
import { ImPhone } from 'react-icons/im';

import Link from '../../Link/Link';

import './TopFooter.scss';

import SocialMedia from '../../Header/TopHeader/SocialMedia';
import A from '../../../shared/Anchor/Anchor';
import { ImageDispatcher } from '../../ImageDispatcher/ImageDispatcher';
import lightOrDark from '../../SlickArrow/colorArrowFunction';

const TopFooter = ({
  isCheckout,
  datiFarmacia,
  logoImage,
  logoFooterLink,
  siteName,
  footerVersion,
  footerTextField,
  discounted,
  primaryColor,
}) => {
  const menu = [
    {
      id: 1,
      title: siteName,
      content: [
        {
          id: 1.1,
          link: '/registrazione',
          title: 'Registrati gratuitamente',
          show: true,
          showInCheckout: false,
        },
        {
          id: 1.2,
          link: '/pagine/contattaci',
          title: 'Contattaci',
          show: true,
          showInCheckout: false,
        },
        {
          id: 1.3,
          link: '/pagine/chi-siamo',
          title: 'Chi siamo',
          show: true,
          showInCheckout: false,
        },
      ],
    },
    {
      id: 2,
      title: 'Informazioni',
      content: [
        {
          id: 2.1,
          link: '/pagine/condizioni-vendita',
          title: 'Condizioni di vendita',
          show: true,
          showInCheckout: true,
        },
        {
          id: 2.2,
          link: '/pagine/modalita-costi-spedizione',
          title: 'Modalità e costi spedizione',
          show: true,
          showInCheckout: true,
        },
        {
          id: 2.3,
          link: '/pagine/resi-e-rimborsi',
          title: 'Resi e rimborsi',
          show: true,
          showInCheckout: true,
        },
        {
          id: 2.3,
          link: '/pagine/pagamenti-accettati',
          title: 'Pagamenti accettati',
          show: true,
          showInCheckout: true,
        },
      ],
    },
    {
      id: 3,
      title: 'Garanzie',
      content: [
        {
          id: 3.1,
          link: '/pagine/informativa-privacy',
          title: 'Privacy policy',
          show: true,
          showInCheckout: true,
        },
        {
          id: 3.1,
          link: '/pagine/informativa-cookie',
          title: 'Cookie policy',
          show: true,
          showInCheckout: true,
        },
        {
          id: 3.3,
          link:
            'https://www.mimit.gov.it/images/stories/documenti/Legal_guarantee_notice_ITN.pdf',
          title: 'Garanzia legale',
          show: true,
          showInCheckout: true,
          external: true,
        },
      ],
    },
    {
      id: 4,
      title: 'Promozioni',
      content: [
        {
          id: 4.1,
          link: '/prodotti-in-offerta',
          title: 'Tutte le offerte',
          show: !!discounted.length,
          showInCheckout: false,
        },
      ],
    },
    {
      id: 5,
      title: 'Seguici su',
      content: [
        {
          id: 5.1,
          link: '',
          title: <SocialMedia datiFarmacia={datiFarmacia} />,
          show:
            !!datiFarmacia.socialTwitterLink ||
            !!datiFarmacia.socialFacebookLink ||
            !!datiFarmacia.socialInstagramLink,
          showInCheckout: false,
        },
      ],
    },
  ];

  const topFooterStyle = css`
    & .container.version-1 {
      height: 100%;
      max-width: 100%;
      padding-left: 10px;
      display: flex;
      flex-direction: column;
      .footer-text-field > p {
        color: #ffff;
      }
      .desktop-footer-menu .address-menu, .mobile-footer-menu .address-menu {
        .col-address > address {
          margin-top: 8px;
          color: #ffff;
        }
        a,
        h2 {
          color: #ffff;
        }
        .col-menu {
          margin-top: 11px;
          .social-media-container .social > a > svg > path {
            fill: #ffff;

          }
        }
        .col-phone-social {
          margin-top: 11px;
          .phone-section  {
            display: flex;
            flex-direction: row;
            align-items: center;
            flex-wrap: wrap;
            color: #ffff;
            svg {
              fill: color: #ffff;
              width: 33px;
              height: 33px;
            }
          }
        }
      }
    }


    .container.version-2 {
      height: 100%;
      display: flex;
      flex-direction: column;

      .desktop-footer-menu .address-menu,
      .mobile-footer-menu .address-menu {
        .col-address > address {
          margin-top: 8px;
          color: #000;
        }
        a,
        h2 {
          color: #000;
        }
        .col-menu .social-media-container .social > a > svg > path {
          fill: #000;
        }
        .col-menu {
          margin-top: 11px;
        }
        .col-phone-social {
          margin-top: 11px;
          .phone-section {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            .h2 {
              color: #4AAD41;
            }
            svg > path {
              fill: #4AAD41;
            }
          }
        }
      }
    }

    & .container.version-3 {
      height: 100%;
      display: flex;
      flex-direction: column;
      .desktop-footer-menu .address-menu, .mobile-footer-menu .address-menu{
        .col-address > address {
          margin-top: 8px;
          color: #000;
        }
        a,
        h2 {
          color: #000;
        }
        .col-menu {
          margin-top: 11px;
        }
        .col-phone-social {
          margin-top: 11px;
          .social-section {
            display: flex;
            align-items: flex-start;
            flex-direction: column;
            h2 {
              font-size: 12px;
              font-weight: 700;
              margin-bottom: 16px;
              color: #000;
            }
            .social-media-container {
              .social {
                display: flex;
                a > svg {
                  width: 15px;
                  height: 15px;
                  path {
                    fill: #000;
                  }
                }
              }
            }
          }
        }
      }
    }
  `;

  const mobileTopFooterStyle = css`
    &.version-1 {
      .mobile-accordion {
        .accordion .accordion__item {
          &:last-of-type {
            border-bottom: 1px solid rgba(255, 255, 255, 0.5);
          }
          .accordion__heading .accordion__button {
            border-top: 1px solid rgba(255, 255, 255, 0.5);
            h2 {
              color: #ffff;
            }
          }
          .accordion__panel {
            ul li {
              margin-bottom: 12px;
              a {
                color: #ffff;
              }
            }
          }
        }
      }
    }
    &.version-2 {
      .address-menu > .col-phone-social > .phone-section {
        .h2 {
          color: #4aad41;
        }
        svg path {
          fill: #4aad41;
        }
      }
    }
    &.version-2,
    &.version-3 {
      .mobile-accordion {
        .accordion .accordion__item {
          &:last-of-type {
            border-bottom: 1px solid rgba(0, 0, 0, 0.5);
          }
          .accordion__heading .accordion__button {
            border-top: 1px solid rgba(0, 0, 0, 0.5);
            h2 {
              color: #000;
            }
          }
          .accordion__panel {
            ul li {
              margin-bottom: 12px;
              a {
                color: #000;
                .social-media-container .social > a > svg path {
                  fill: #000;
                }
              }
            }
          }
        }
      }
    }
  `;

  const renderLink = item =>
    item.external ? (
      <A href={item.link} target="_blank" rel="noopener noreferrer">
        {item.title}
      </A>
    ) : (
      <Link to={item.link}>{item.title}</Link>
    );

  return (
    <div
      className="top-footer"
      style={{ paddingTop: footerVersion === 2 ? '0px' : '40px' }}
      css={topFooterStyle}
    >
      <div className={`container version-${footerVersion} `}>
        {footerTextField && (
          <div className="footer-text-field">
            <p>{footerTextField}</p>
          </div>
        )}
        {/* DESKTOP */}
        <div className="desktop-footer-menu">
          <div className="address-menu">
            <div className="col-address">
              {!!logoFooterLink ? (
                <a href={logoFooterLink} target="_blank">
                  <ImageDispatcher
                    src={logoImage}
                    alt={logoFooterLink}
                    className="logo"
                  />
                </a>
              ) : (
                <A href="/">
                  <ImageDispatcher
                    src={logoImage}
                    alt={siteName}
                    className="logo"
                  />
                </A>
              )}
              <address>
                {datiFarmacia.companyName}
                <br />
                {datiFarmacia.address1}
                {datiFarmacia.address2 && ' ' + datiFarmacia.address2}
                {datiFarmacia.zipcode && ' - ' + datiFarmacia.zipcode}
                {datiFarmacia.city && ' ' + datiFarmacia.city}
                {datiFarmacia.province && ' (' + datiFarmacia.province + ')'}
                <br />
                <div>P. IVA {datiFarmacia.vatCode}</div>
              </address>
              <div
                style={{
                  fontSize: 10,
                  marginTop: 8,
                  color:
                    footerVersion === 1
                      ? lightOrDark(primaryColor) === 'dark'
                        ? '#fff'
                        : '#000'
                      : '#000',
                }}
              >
                <i>
                  {datiFarmacia.siteName} è un sito gestito da{' '}
                  {datiFarmacia.companyName} – {datiFarmacia.address1}
                  {datiFarmacia.address2 && ' ' + datiFarmacia.address2}
                  {datiFarmacia.zipcode && ' - ' + datiFarmacia.zipcode}
                  {datiFarmacia.city && ' ' + datiFarmacia.city}
                  {datiFarmacia.province &&
                    ' (' + datiFarmacia.province + ')'}{' '}
                  - P. IVA {datiFarmacia.vatCode}
                </i>
              </div>
              <div className="info">
                {[
                  datiFarmacia.linkDrugsAuthorizedSite,
                  datiFarmacia.showLinkDrugsAuthorizedSiteFooter,
                ].every(rule => !!rule) && (
                  <div className="authorized-site">
                    <A
                      className="store-authorized-link"
                      href={datiFarmacia.linkDrugsAuthorizedSite}
                      target="_blank"
                      aria-label="Link all'autorizzazione ministeriale della farmacia"
                    >
                      <ImageDispatcher
                        src="/static/images/logo_farmacia_autorizzata.png"
                        alt="Logo farmacia autorizzata"
                      />
                    </A>
                  </div>
                )}
                {[
                  datiFarmacia.linkDrugsAuthorizedSiteVet,
                  datiFarmacia.showLinkDrugsAuthorizedSiteFooter,
                ].every(rule => !!rule) && (
                  <div className="authorized-site">
                    <A
                      className="store-authorized-link"
                      href={datiFarmacia.linkDrugsAuthorizedSiteVet}
                      target="_blank"
                      aria-label="Link all'autorizzazione ministeriale della farmacia"
                    >
                      <ImageDispatcher
                        src="/static/images/logo_farmacia_autorizzata_vet.png"
                        alt="Logo farmacia autorizzata"
                      />
                    </A>
                  </div>
                )}
                {!!datiFarmacia.accessibilityLink && (
                  <div className="authorized-site">
                    <A
                      className="store-authorized-link"
                      href={datiFarmacia.accessibilityLink}
                      target="_blank"
                      aria-label="Link alla dichirazione di accessibilità"
                      style={{ backgroundColor: 'white' }}
                    >
                      <ImageDispatcher
                        src="/static/images/logo_farmacia_accessibile.png"
                        alt="Logo della dichiarazione di accessibilità"
                      />
                    </A>
                  </div>
                )}
              </div>
            </div>

            {!!menu &&
              menu
                .filter(col =>
                  col.content.some(
                    item =>
                      item.show && (isCheckout ? item.showInCheckout : true)
                  )
                )
                .map(col => {
                  return (
                    <div className="col-menu" key={col.id}>
                      <h2 style={{ wordBreak: 'break-word' }}>{col.title}</h2>
                      <ul>
                        {footerVersion !== 3
                          ? col.content
                              .filter(item => !!item.show)
                              .map(item => {
                                return (
                                  <li key={item.id}>
                                    {item.h4 && (
                                      <div className="follow-us">
                                        <h3 className="follow-us-title">
                                          {item.h4}
                                        </h3>
                                      </div>
                                    )}
                                    <h3>{renderLink(item)}</h3>
                                  </li>
                                );
                              })
                          : col.content.map(item => {
                              return (
                                <li key={item.id}>
                                  <h3>{renderLink(item)}</h3>
                                </li>
                              );
                            })}
                      </ul>
                    </div>
                  );
                })}

            {!!datiFarmacia.phone && (
              <div
                className="col-phone-social"
                style={{ display: 'flex', flexDirection: 'column', gap: 16 }}
              >
                {footerVersion !== 3 ? (
                  <div className="phone-section">
                    <a
                      href={`tel:${datiFarmacia.phone}`}
                      style={{ display: 'flex', alignItems: 'center', gap: 8 }}
                    >
                      <ImPhone />
                      <div className="h2">{datiFarmacia.phone}</div>
                    </a>
                  </div>
                ) : null}
                {!!datiFarmacia.phone2 && (
                  <div className="phone-section">
                    <a
                      href={`https://wa.me/${datiFarmacia.phone2}`}
                      rel="noopener noreferrer"
                      target="_blank"
                      style={{ display: 'flex', alignItems: 'center', gap: 8 }}
                    >
                      <FaWhatsapp />
                      <div className="h2">{datiFarmacia.phone2}</div>
                    </a>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>

        {/* MOBILE */}
        <div
          className={`mobile-footer-menu version-${footerVersion}`}
          css={mobileTopFooterStyle}
        >
          <div className="address-menu">
            <div className="col-address">
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                }}
              >
                <ImageDispatcher
                  src={logoImage}
                  alt={siteName}
                  className="logo"
                />
                <div className="info" style={{ marginTop: 0 }}>
                  {[
                    datiFarmacia.linkDrugsAuthorizedSite,
                    datiFarmacia.showLinkDrugsAuthorizedSiteFooter,
                  ].every(rule => !!rule) && (
                    <div className="authorized-site">
                      <A
                        className="store-authorized-link"
                        href={datiFarmacia.linkDrugsAuthorizedSite}
                        target="_blank"
                        aria-label="Link all'autorizzazione ministeriale della farmacia"
                      >
                        <ImageDispatcher
                          src="/static/images/logo_farmacia_autorizzata.png"
                          alt="Logo farmacia autorizzata"
                        />
                      </A>
                    </div>
                  )}
                  {[
                    datiFarmacia.linkDrugsAuthorizedSiteVet,
                    datiFarmacia.showLinkDrugsAuthorizedSiteFooter,
                  ].every(rule => !!rule) && (
                    <div className="authorized-site">
                      <A
                        className="store-authorized-link"
                        href={datiFarmacia.linkDrugsAuthorizedSiteVet}
                        target="_blank"
                        aria-label="Link all'autorizzazione ministeriale della farmacia"
                      >
                        <ImageDispatcher
                          src="/static/images/logo_farmacia_autorizzata_vet.png"
                          alt="Logo farmacia autorizzata"
                        />
                      </A>
                    </div>
                  )}
                  {!!datiFarmacia.accessibilityLink && (
                    <div className="authorized-site">
                      <A
                        className="store-authorized-link"
                        href={datiFarmacia.accessibilityLink}
                        target="_blank"
                        aria-label="Link alla dichirazione di accessibilità"
                        style={{ backgroundColor: 'white' }}
                      >
                        <ImageDispatcher
                          src="/static/images/logo_farmacia_accessibile.png"
                          alt="Logo della dichiarazione di accessibilità"
                        />
                      </A>
                    </div>
                  )}
                </div>
              </div>
              <address>
                {datiFarmacia.companyName}
                <br />
                {datiFarmacia.address1}
                {datiFarmacia.address2 && ' ' + datiFarmacia.address2}
                {datiFarmacia.zipcode && ' - ' + datiFarmacia.zipcode}
                {datiFarmacia.city && ' ' + datiFarmacia.city}
                {datiFarmacia.province && ' (' + datiFarmacia.province + ')'}
                <br />
                <div>P. IVA {datiFarmacia.vatCode}</div>
              </address>
              <div
                style={{
                  fontSize: 10,
                  marginTop: 8,
                  marginBottom: 8,
                  color:
                    footerVersion === 1
                      ? lightOrDark(primaryColor) === 'dark'
                        ? '#fff'
                        : '#000'
                      : '#000',
                }}
              >
                <i>
                  {datiFarmacia.siteName} è un sito gestito da{' '}
                  {datiFarmacia.companyName} – {datiFarmacia.address1}
                  {datiFarmacia.address2 && ' ' + datiFarmacia.address2}
                  {datiFarmacia.zipcode && ' - ' + datiFarmacia.zipcode}
                  {datiFarmacia.city && ' ' + datiFarmacia.city}
                  {datiFarmacia.province &&
                    ' (' + datiFarmacia.province + ')'}{' '}
                  - P. IVA {datiFarmacia.vatCode}
                </i>
              </div>
            </div>
            {footerVersion !== 3 &&
              [datiFarmacia.phone, datiFarmacia.phone2].some(
                phone => !!phone
              ) && (
                <div
                  className="col-phone-social"
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: 16,
                    marginTop: 24,
                  }}
                >
                  {!!datiFarmacia.phone && (
                    <div
                      className="phone-section"
                      style={{
                        padding: 8,
                        border: '1px solid #ccc',
                        borderRadius: 8,
                      }}
                    >
                      <a
                        href={`tel:${datiFarmacia.phone}`}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 8,
                        }}
                      >
                        <ImPhone />
                        <div className="h2">{datiFarmacia.phone}</div>
                      </a>
                    </div>
                  )}
                  {!!datiFarmacia.phone2 && (
                    <div
                      className="phone-section"
                      style={{
                        padding: 8,
                        border: '1px solid #ccc',
                        borderRadius: 8,
                      }}
                    >
                      <a
                        href={`https://wa.me/${datiFarmacia.phone2}`}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 8,
                        }}
                      >
                        <FaWhatsapp />
                        <div className="h2">{datiFarmacia.phone2}</div>
                      </a>
                    </div>
                  )}
                </div>
              )}
          </div>
          {!!menu && (
            <div className="mobile-accordion">
              <Accordion allowZeroExpanded allowMultipleExpanded>
                {menu
                  .filter(col =>
                    col.content.some(
                      item =>
                        item.show && (isCheckout ? item.showInCheckout : true)
                    )
                  )
                  .map(col => {
                    return (
                      <AccordionItem key={col.id}>
                        <AccordionItemHeading>
                          <AccordionItemButton>
                            <div className="h2">
                              {col.title} <FaChevronDown />
                            </div>
                          </AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel>
                          <ul>
                            {col.content
                              .filter(item => !!item.show)
                              .map(item => {
                                return (
                                  <li key={item.id}>{renderLink(item)}</li>
                                );
                              })}
                          </ul>
                        </AccordionItemPanel>
                      </AccordionItem>
                    );
                  })}
              </Accordion>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TopFooter;
